// src/pages/sozlesmeler/KvkkKisilerTablo.jsx
import React from "react";

const KvkkKisilerTablo = () => (
  
  <div className="overflow-x-auto my-4">
    <br></br>
    <table className="min-w-full border text-xs">
      <thead>
        <tr>
          <th className="border px-2 py-1 text-grayy">Kişisel Verileriniz</th>
          <th className="border px-2 py-1 text-grayy">İşleme Amaçlarımız</th>
          <th className="border px-2 py-1 text-grayy">Yasal/Hukuki Sebepler</th>
          <th className="border px-2 py-1 text-grayy">
            Sistemimize Ulaştığı Ortam
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border px-2 py-1 text-grayy">
            İsim Soyisim, E-Posta, Telefon Numarası
          </td>
          <td className="border px-2 py-1 text-grayy">
            www.juniorscenter.com sitemize üyeliğinizi gerçekleştirmek, üyelik
            hesabınızı onaylamak, üyelik sözleşmesinin kurulması için asgari
            seviyede gerekli olması, 5651 ve 5237 sayılı Kanunlar gereği adli ve
            idari makamlar tarafından talep edilmesi durumunda bu yükümlülüğün
            yerine getirilmesi
          </td>
          <td className="border px-2 py-1 text-grayy">
            Üyelik sözleşmesinin kurulması ve ifası, 5651 sayılı Kanun'dan
            kaynaklanan Yer Sağlayıcı Yükümlülüklerinin yerine getirilmesi için
            zorunlu olması, Önceden aldığımız açık rızanız
          </td>
          <td className="border px-2 py-1 text-grayy">www.juniorscenter.com</td>
        </tr>
        <tr>
          <td className="border px-2 py-1 text-grayy">
            IP Adresi, Trafik Verisi, Çerezler
          </td>
          <td className="border px-2 py-1 text-grayy">
            5651 ve 5237 sayılı Kanunlar gereği adli ve idari makamlar
          </td>
          <td className="border px-2 py-1 text-grayy">
            5651 sayılı Kanun çerçevesinde Yer sağlayıcı olarak
          </td>
          <td className="border px-2 py-1 text-grayy">www.juniorscenter.com</td>
        </tr>
        <tr>
          <td className="border px-2 py-1 text-grayy">
            Kullanılan Cihaz, İşletim Sistemi ve Tarayıcı
          </td>
          <td className="border px-2 py-1 text-grayy">
            tarafından talep edilmesi durumunda bu yükümlülüğün yerine
            getirilmesi, Üyelerimizi/ Potansiyel üyelerimizi daha yakından
            tanımaya ve bu doğrultuda web sitemizin altyapısını geliştirmek
            amacıyla meşru menfaatimizin gerçekleştirilmesi
          </td>
          <td className="border px-2 py-1 text-grayy">
            hukuki yükümlülüğümüzün yerine getirebilmesi için zorunlu olması,
            Veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu
            olması, Önceden aldığımız açık rızanız
          </td>
          <td className="border px-2 py-1 text-grayy"></td>
        </tr>
        <tr>
          <td className="border px-2 py-1 text-grayy">
            Proje Bildirim iletimi, başvuru, atama logları
          </td>
          <td className="border px-2 py-1 text-grayy">
            Üyelerimizin hangi hizmetleri kullandığı, 5651 ve 5237 sayılı
            Kanunlar gereği adli ve idari makamlar tarafından talep edilmesi
            durumunda bu yükümlülüğün yerine getirilmesi
          </td>
          <td className="border px-2 py-1 text-grayy">
            Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin
            zorunlu olması, veri sorumlusunun meşru menfaatleri için veri
            işlenmesinin zorunlu olması, Önceden aldığımız açık rızanız
          </td>
          <td className="border px-2 py-1 text-grayy">www.juniorscenter.com</td>
        </tr>
        <tr>
          <td className="border px-2 py-1 text-grayy">
            Profil Resmi, Hakkınızda, Uzmanlıklar, Anket, yorumlama ve
            puanlamalar
          </td>
          <td className="border px-2 py-1 text-grayy">
            www.juniorscenter.com sitemizdeki üyelik hizmetinden en üst seviyede
            yararlanmak amacıyla üye tarafından/tarafına ihtiyari olarak bu
            bilgilerin sisteme girilmesi ve alenileştirilmesi
          </td>
          <td className="border px-2 py-1 text-grayy">
            Veri sahibinin kendisi tarafından alenileştirilmiş olması, Bir
            hakkın tesisi, kullanılması veya korunması için veri işlemenin
            zorunlu olması,
          </td>
          <td className="border px-2 py-1 text-grayy">www.juniorscenter.com</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default KvkkKisilerTablo;
